import { Reveal, Label } from "./Motion";
import { CHAPTERS, MANIFESTO_IMG } from "../data";

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto" className="relative py-28 md:py-40">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <Reveal><Label>The name, in three chapters</Label></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-[#2c2826]">
              A brand written<br /><span className="italic text-[#985F47]">word by word.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-sm text-[#5a5451] leading-relaxed">
              Pageshier Casa is more than a label — it is a small philosophy of living
              beautifully, folded into a single name.
            </p>
          </Reveal>
          <Reveal delay={0.15} className="mt-10 overflow-hidden aspect-[4/3] hidden lg:block">
            <img src={MANIFESTO_IMG} alt="Minimal warm decor" className="h-full w-full object-cover" />
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.no} delay={i * 0.06}>
              <div className={`relative py-10 md:py-14 ${i !== CHAPTERS.length - 1 ? "border-b border-[#ddd4c7]" : ""}`}>
                <span className="absolute -top-2 right-0 font-serif text-[26vw] md:text-[12rem] leading-none text-[#2c2826]/[0.05] pointer-events-none select-none">
                  {c.no}
                </span>
                <div className="relative">
                  <Label>{c.no} &mdash; {c.meaning}</Label>
                  <h3 className="mt-3 font-serif text-5xl md:text-7xl text-[#2c2826] italic">{c.word}</h3>
                  <p className="mt-5 max-w-lg text-[#5a5451] text-base md:text-lg leading-relaxed">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
